import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ShoppingCartState } from '../../../shopping-cart-back/actions/standalone';
import { selectShoppingCartId } from '../../../shopping-cart-back/actions/selector';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SuggestPackageAtBeginningService {
  shoppingCartId$ = this.store.pipe(select(selectShoppingCartId));

  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  save(x: boolean) {
    this.shoppingCartId$.pipe(first()).subscribe((shoppingCartId) => {
      localStorage.setItem(
        `${shoppingCartId}_suggestPackageAtBeginning`,
        JSON.stringify(x)
      );
    });
  }

  saveAlreadyOrdered(x: boolean) {
    this.shoppingCartId$.pipe(first()).subscribe((shoppingCartId) => {
      localStorage.setItem(
        `${shoppingCartId}_freePackageAlreadyOrdered`,
        JSON.stringify(x)
      );
    });
  }

  loadAlreadyOrdered() {
    let shoppingCartId = '';
    this.shoppingCartId$.pipe(first()).subscribe((x) => {
      shoppingCartId = x;
    });
    return JSON.parse(
      localStorage.getItem(`${shoppingCartId}_freePackageAlreadyOrdered`)
    );
  }

  load() {
    let shoppingCartId = '';
    this.shoppingCartId$.pipe(first()).subscribe((x) => {
      shoppingCartId = x;
    });
    return (
      JSON.parse(
        localStorage.getItem(`${shoppingCartId}_suggestPackageAtBeginning`)
      ) ||
      JSON.parse(
        localStorage.getItem(`${shoppingCartId}_freePackageAlreadyOrdered`)
      )
    );
  }
}
